// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_tE_","cls2":"Header-cls2_h-U Header-cls1_tE_"};